import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import glamorous from 'glamorous'
import Button from '../../blocks/Button'
import { color } from '../../../style'
import { tsDiffUntilNow } from '../../../common';

const topPadding = {
  paddingTop: 20
}

const GdprContainer = glamorous.div({
  margin: '0 auto',
  paddingTop: 20,
  textAlign: 'center'
})

const Header = glamorous.h2({
  color: color.BRAND_1_DARK,
  margin: 0
})

const Description = glamorous.p({
  fontSize: 16,
  margin: '0 auto',
  maxWidth: 500,
  ...topPadding
})

const Note = glamorous.p({
  fontStyle: 'italic',
  margin: '0 auto',
  maxWidth: 500,
  ...topPadding
})

const DownloadUrl = glamorous.a({
  display: 'block',
  paddingBottom: 20,
  ...topPadding
})

const handleDownload = (downloadLink) => {
  window.open(downloadLink, "_blank");
}

function gdprInitial(created) {
  if(created) {
    return (
      <GdprContainer>
        <Header>Your information request may take up to 24 hours to process.</Header>
        <Description>We will send you an email when the process is complete. The email will contain a link to a zip file containing all of your information.</Description>
        <Note>Note: The zip file will be available for download for 7 days from the time you receive the email, after which the file will be deleted.</Note>
      </GdprContainer>
    )
  } else {
    return null;
  }
}

function gdprReminder(createdDate) {
  if(!createdDate) return null;

  const HOURS_SINCE = tsDiffUntilNow(createdDate.date, 'hours');

  if(HOURS_SINCE < 24) {
    return (
      <GdprContainer>
        <Header>You have already submitted an information request.</Header>
        <Header>Your information request may take up to 24 hours to process.</Header>
        <Description>We will send you an email when the process is complete. The email will contain a link to a zip file containing all of your information.</Description>
        <Note>Note: The zip file will be available for download for 7 days from the time you receive the email, after which the file will be deleted.</Note>
      </GdprContainer>
    )
  } else {
    return null
  }
}

function gdprDownload(downloadUrl, workedDate) {
  if(downloadUrl !== null && workedDate !== null) {
    return (
      <GdprContainer>
        <Header>You have an information request available for download </Header>
        <Header>at the link below, or by clicking the "Download my data" button.</Header>
        <DownloadUrl href={downloadUrl} target='_blank'>{downloadUrl}</DownloadUrl>
        <Note>Note: This file will expire and be deleted from our servers in 7 days.</Note>
        <Button variant="primary" onClick={() => handleDownload(downloadUrl)}>Download my data</Button>
      </GdprContainer>
    )
  } else {
    return null;
  }
}

class GdprView extends Component {
  componentWillMount() {
    if(this.props.gdpr && !this.props.gdpr.item) {
      browserHistory.replace('/gdpr');
    }
  }

  render() {
    const {
      gdpr
    } = this.props;

    const item = gdpr.item;
    if(!item) return null;

    return (
      <div>
        {gdprInitial(item.created)}
        {gdprReminder(item.created_at)}
        {gdprDownload(item.url, item.worked_dt)}
      </div>
    );
  }
}

export default GdprView;



// WEBPACK FOOTER //
// ./src/components/pages/GDPR/GdprView.jsx